// React / Next
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/coos')({
  beforeLoad: () => {
    throw redirect({ to: '/landing-pages/$slug', params: { slug: 'coos' } });
  },
});
